/**
 * Convert a human-readable label into a lowercase snake_case slug: lowercase,
 * runs of non-alphanumeric characters collapse to a single underscore, and
 * leading/trailing underscores are trimmed.
 *
 * Generic form-key / identifier slug. Note: `slugifyColumnName` in the
 * campaigns module is intentionally separate — it layers column-variable rules
 * (a `column_` prefix for digit-leading slugs and a 64-char cap) on top and
 * preserves pre-existing underscore runs, so it can't share this exact logic
 * without changing template-variable behavior.
 *
 * @param value - The label to slugify.
 * @returns The snake_case slug (may be empty if the input has no alphanumerics).
 */
export function slugify(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
}
